export const AppendWebLinks = {
  "title": "Download Status",
  "stop": "Stop",
  "ok": "OK",
  "Table": {
    "Url": "URL",
    "Status": "State",
    "Failed": "Conversion Failed",
    "Successful": "Successful"
  },
  "connect": "Connecting",
  "Downloading": "Downloading",
  "Error": "Conversion Failed"
}